import { useMediaQuery, useTheme } from '@mui/material'
import React, { ComponentProps } from 'react'
import LazyHydrate from 'react-lazy-hydration'

export type LazyComponentProps = Omit<ComponentProps<typeof LazyHydrate>, 'whenVisible' | 'whenIdle'> & {
  //
}

export const LazyComponent: React.FC<LazyComponentProps> = ({ children, ...props }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <LazyHydrate whenVisible={!isDesktop} whenIdle={isDesktop} { ...props }>
      {children}
    </LazyHydrate>
  )
}